import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import Styles from "./Modules.module.css";

/**
 * @typedef {import("@prismicio/client").Content.ModulesSlice} ModulesSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ModulesSlice>} ModulesProps
 * @param {ModulesProps}
 */
const Modules = ({ slice: { primary, items } }) => {
	return (
		<section className={Styles.wrapper}>
			<div className={Styles.container} data-contain="true">
				<div className={Styles.heading}>
					<PrismicRichText field={primary?.heading} />
				</div>
				{items.map((item, index) => (
					<div className={Styles.module} key={index}>
						<div className={Styles.col}>
							<h3 className={Styles.title}>{item.title}</h3>
							<PrismicRichText field={item?.content} />
						</div>
						<div className={Styles.col}>
							<PrismicNextImage field={item?.image} />
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default Modules;
